<template>
  <div class="upload-avatar">
    <Header />
    <div class="avatar-main">
      <div class="text">
        <van-uploader
          v-model="fileList"
          :after-read="afterRead"
          :before-read="beforeRead"
          max-count="1"
        />
        <div>支持jpg、png格式</div>
      </div>
      <div class="upload" @click="submit">upload</div>
    </div>
    <Footer />
  </div>
</template>
<script>
import Header from "./mycom/header.vue";
import Footer from "./mycom/footer.vue";
import { Toast } from "vant";
import { Notify } from "vant";
import { avatarUrl, accountsAvatar, accounts } from "@/api/api.js";
export default {
  components: { Header, Footer },
  data() {
    return {
      fileList: [],
      avatar: "",
      avatarUrl: "",
    };
  },
  methods: {
    afterRead(file) {
      this.avatar = file.content;
      const params = {
        source: this.avatar,
      };
      avatarUrl(params).then((res) => {
        if (res.code === 200) {
          this.avatarUrl = res.data.avatarUrl;
          Notify({ type: "success", message: res.errors[0] });
        } else {
          Notify({ type: "danger", message: res.errors[0] });
        }
      });
    },
    beforeRead(file) {
      if (!file.type.startsWith("image/")) {
        Toast("Please upload pictures");
        return false;
      }
      return true;
    },
    async submit() {
      const loginInfo = JSON.parse(localStorage.getItem("LOGIN_INFO"));
      const params = {
        id: loginInfo.id,
        avatarUrl: this.avatarUrl,
      };
      await accountsAvatar(params).then((res) => {
        if (res.code === 200) {
          this.updateUserInfo(loginInfo.id);
          Notify({ type: "success", message: res.errors[0] });
          this.initPage();
        } else {
          Notify({ type: "danger", message: res.errors[0] });
        }
      });
    },
    updateUserInfo(userId) {
      const params = {
        id: userId,
      };
      accounts(params).then((res) => {
        if (res.code === 200) {
          res.data.avatarUrl = res.data.avatarUrl + "?v=" + Date.now();
          this.$store.commit("setAccountInfo", res.data);
        }
      });
    },
    //获取用户信息
    async initPage() {
      //用户信息
      const loginInfo = JSON.parse(localStorage.getItem("LOGIN_INFO"));
      const params = {
        id: loginInfo.id,
      };
      await accounts(params).then((res) => {
        if (res.code === 200) {
          this.$store.commit("setAccountInfo", res.data);
          setTimeout(() => {
            this.$router.go(0);
          }, 100);
        }
      });
    },
  },
};
</script>
<style scoped>
.upload-avatar {
  padding-top: 40px;
  min-height: calc(100vh - 40px);
  background-color: #fff;
}
header {
  position: fixed;
  top: 0;
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  background: #ffffff;
  z-index: 999;
  box-shadow: 0px 3px 6px 1px #c6c5c6;
}
.avatar-main {
  width: calc(100% - 175px);
  padding: 20px 87.5px;
  display: flex;
  justify-content: space-between;
  align-items: flex-end;
}
.text {
  display: flex;
  flex-direction: column;
}
.text > div {
  font-size: 8.75px;
  color: #666;
  margin-top: 20px;
}
.avatar-main > .upload {
  width: 56.875px;
  height: 18.75px;
  line-height: 18.75px;
  background: #2e67ea;
  border-radius: 2.5px;
  font-size: 10px;
  text-align: center;
  color: #fff;
  margin-left: 20px;
}
</style>


// WEBPACK FOOTER //
// src/components/uploadAvatar.vue